module.exports = __webpack_public_path__ + "02_glasses_red.da653b96.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer4/02_glasses_red.png
// module id = oX3J
// module chunks = 0